import React from "react";
import { GovernanceAuditList } from "@/components/main/governance/GovernanceAuditList";
import {
  LogFeed,
  LogSlideOver,
} from "@/components/main/governance/LogSlideOver";
import { useGovernanceAudit } from "@/components/main/governance/useGovernanceAudit";

interface Props {
  open: boolean;
  onClose: () => void;
  orgId: string | null;
  /// Narrows to one space. Omit for the whole org's log.
  spaceId?: string;
  title: string;
  showSpace?: boolean;
  /// Read through the platform admin's door.
  admin?: boolean;
}

export const GovernanceAuditPanel: React.FC<Props> = ({
  open,
  onClose,
  orgId,
  spaceId,
  title,
  showSpace,
  admin,
}) => (
  <LogSlideOver open={open} onClose={onClose} title={title}>
    {(mounted) => (
      <GovernanceFeed
        orgId={mounted ? orgId : null}
        spaceId={spaceId}
        showSpace={showSpace}
        admin={admin}
      />
    )}
  </LogSlideOver>
);

const GovernanceFeed: React.FC<{
  orgId: string | null;
  spaceId?: string;
  showSpace?: boolean;
  admin?: boolean;
}> = ({ orgId, spaceId, showSpace, admin }) => {
  const feed = useGovernanceAudit(orgId, spaceId, undefined, admin);
  return (
    <LogFeed feed={feed} loadingLabel="Loading events…">
      <GovernanceAuditList
        entries={feed.entries}
        names={feed.names}
        showSpace={showSpace}
      />
    </LogFeed>
  );
};
